var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7678 20.7678C52.7441 19.7915 52.7441 18.2086 51.7678 17.2322L35.8579 1.32234C34.8816 0.346026 33.2986 0.346026 32.3223 1.32234C31.346 2.29865 31.346 3.88156 32.3223 4.85787L46.4645 19L32.3223 33.1421C31.346 34.1185 31.346 35.7014 32.3223 36.6777C33.2986 37.654 34.8816 37.654 35.8579 36.6777L51.7678 20.7678ZM-4.37114e-07 21.5L50 21.5L50 16.5L4.37114e-07 16.5L-4.37114e-07 21.5Z",
    fill: "#E52812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.f6f1c644b86e292cddb1423a068a8490.svg";
export { ForwardRef as ReactComponent };